import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ArticleService } from 'src/app/services/article.service';
import { PATHS } from 'shared/paths';
import { Article } from 'shared/types';
import { Section, Page } from 'shared/location-enums';
import { LANGUAGE } from '../../../../../shared/injection-tokens';
import { Language } from '../../../../../shared/salesforce-types';

@Component({
    selector: 'app-about-gard-section',
    templateUrl: './h2-about-gard.component.html',
})
export class H2AboutGardComponent {
    private readonly desktopBreakpoint = 992;
    private readonly mobileClampLines = 8;
    private readonly unclampedLines = 1000;

    buttonArticle: Article;
    contentArticle: Article;
    articleImagesPath = PATHS.articleImages;
    aboutUrl = `/${PATHS[this.language.value].about}`;
    imageUrl: string;
    bodyMaxLines = this.unclampedLines;

    constructor(articleService: ArticleService, @Inject(LANGUAGE) private language: BehaviorSubject<Language>, @Inject(DOCUMENT) private document: Document) {
        this.setBodyMaxLines();
        this.contentArticle = articleService.getOne(Page.home, Section.aboutGARD, undefined, 1);
        this.buttonArticle = articleService.getOne(Page.home, Section.aboutGARD, undefined, 2);

        this.imageUrl = this.articleImagesPath + this.contentArticle.images[0]?.url + '-600.webp';
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.setBodyMaxLines();
    }

    private setBodyMaxLines() {
        const width = this.document.defaultView?.innerWidth ?? this.desktopBreakpoint;
        this.bodyMaxLines = width >= this.desktopBreakpoint ? this.unclampedLines : this.mobileClampLines;
    }
}
